import React from 'react';

const Dashboard = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Dashboard Test</h1>
      <p>If you see this, Dashboard is rendering!</p>
    </div>
  );
};

export default Dashboard;